import * as T from './types'

const mutations = {
    [T.SET_APP_DETAIL](state, payload) {
        state.app = payload
    },

    [T.SET_PAGES_MAP](state, payload) {
        state.pagesMap = payload
    },

    [T.SET_META_PAGES](state, payload) {
        state.metaPages = payload
    },

    [T.SET_CONF_META_MAP](state, payload) {
        state.confMetaMap = payload
    },

    [T.SET_CONF_META](state, payload) {
        state.confMeta = payload
    },

    [T.SET_CONF_PAGES_MAP](state, payload) {
        state.confPagesMap = payload
    },
    [T.SET_CONF_PAGES](state, payload) {
        state.confPages = payload
    },

    [T.SET_MODAL](state, payload) {
        state.modal = payload
    },

    [T.SET_CLIENT](state, payload) {
        state.client = payload
    },

    [T.SET_DYNAMIC_META](state, payload) {
        state.dynamicMeta = { ...state.dynamicMeta, ...payload }
    },

    [T.SET_APP_SETTING](state, payload) {
        state.appSetting = payload
    },

    // 更新缓存组件元数据
    [T.INIT_COMPONENT_INFO_CACHE](state, payload) {
        state.componentInfoCache = { ...state.componentInfoCache, ...payload }
    },

    // 元数据变化重置组件缓存
    [T.RESET_CACHE](state) {
        state.componentInfoCache = {}
        state.dynamicMeta = {}
    },

    // 路由变化时重置缓存
    [T.RESET_INFO_CACHE](state) {
        state.componentInfoCache = {}
        state.dynamicMeta = {}
    },
    // 开发本地自定义组件
    [T.SET_LOCAL_COMPONENT](state, payload) {
        state.localComponents = payload
    },
    // 热更新组件的meta.json数据
    [T.UPDATE_LOCAL_COMPONENT](state, payload) {
        state.localComponents = state.localComponents.map(comp => {
            if (comp.realName === payload.name) {
                return { ...payload, realName: comp.realName }
            }
            return comp
        })
    },
}

export default mutations
